import { styled } from "~/generated/styled-system/jsx"
import { iconChip as iconChipRecipe } from "~/generated/styled-system/recipes"

/** Round icon holder (solid palette chip or outline ring). Decorative: render it `aria-hidden`. */
export const IconChip = styled("span", iconChipRecipe)
